import { z } from "zod";

export const ObjectUpdateSchema = z.object({
  id: z.string(),
  firmId: z.string(),
  createdByUserId: z.string(),
  creator: z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
  }),
  message: z.string(),
  dateCreated: z.string(),
  dateModified: z.string(),
  anchorObjectType: z.enum(["matter", "matter_expense"]),
  anchorObjectId: z.string(),
  anchorLabel: z.string().nullable(),
  matterId: z.string(),
  matterSnapshot: z.object({
    statusIdAtCreation: z.string(),
    statusLabelAtCreation: z.string(),
  }),
  expenseSnapshot: z
    .object({ paidStatusAtCreation: z.string().nullable() })
    .nullable(),
  canEdit: z.boolean(),
  canDelete: z.boolean(),
});

export const ObjectUpdatePageSchema = z.object({
  items: z.array(ObjectUpdateSchema),
  nextCursor: z.string().nullable(),
  matterId: z.string(),
  canCreate: z.boolean(),
});

export type ObjectUpdate = z.infer<typeof ObjectUpdateSchema>;
export type ObjectUpdatePage = z.infer<typeof ObjectUpdatePageSchema>;
export type UpdateAnchorType = ObjectUpdate["anchorObjectType"];
